import { isBrowser } from "../../utils/environmentDetection/library";
import { identifyNewsletterSourceAPI } from "../../utils/newsletters";

export const ALAN_API = identifyNewsletterSourceAPI();
export const NEWSLETTERS_ENDPOINT = `${ALAN_API}/newsletter/get_active_newsletters?source=${encodeURIComponent(
    isBrowser() ? window.location.host : "server"
)}`;
export const SINGLE_NEWSLETTER_ENDPOINT = `${ALAN_API}/newsletter`;
export const SUBSCRIBE_ENDPOINT = `${ALAN_API}/subscription/subscribe`;
export const MIDDLEWARE_ENDPOINT = `${ALAN_API}/middlewareerrors/add`;
